import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Col,
  Row,
} from "reactstrap";
import './PrimaryContact.css'
import Storage from "../services/Storage";
import { Roles } from '../constants/Roles';

const PrimaryContact = ({ previewData, userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ])
    }
  }


  return (
    <div id='contactInfo'>
      <Row>
        <Col xs={12}>
          <div className='d-flex align-items-center '>
            <div className='main-title'>Primary Contact Information
              {roleName && (roleName === Roles.TM_NAME || roleName === Roles.BH_NAME || (roleName === Roles.SH_NAME && previewData.created_by && previewData.created_by === roleId)) ?
                <i onClick={() => {
                  setBreadcrumbsRecord();
                  navigate(`/pages/primary-contact-info/${Storage.getAddNewDealerId() ? Storage.getAddNewDealerId() : userId}`)
                }} className='fa fa-edit editButton noprint'></i>
                : ""}
            </div>
          </div>
        </Col>
        <Col xs={12}>
          <div className='contactdatablock'>
            {previewData.primary_contact_name &&
              <div className='info'>
                <div className='common-heading'>Name</div>
                <div className='subData'>{previewData.primary_contact_name}</div>
              </div>
            }
            {previewData.primary_contact_designation &&
              <div className='info'>
                <div className='common-heading'>Designation</div>
                <div className='subData'>{previewData.primary_contact_designation}</div>
              </div>
            }
            {previewData.primary_contact_mobile &&
              <div className='info'>
                <div className='common-heading'>Mobile No</div>
                <div className='subData'>{previewData.primary_contact_mobile}</div>
              </div>
            }
            {previewData.primary_contact_whatsapp &&
              <div className='info'>
                <div className='common-heading'>Whatsapp No</div>
                <div className='subData'>{previewData.primary_contact_whatsapp}</div>
              </div>
            }
            {previewData.primary_contact_email &&
              <div className='info'>
                <div className='common-heading'>Email</div>
                <div className='subData'>{previewData.primary_contact_email}</div>
              </div>
            }
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default React.memo(PrimaryContact);